<template>
    <div class="p-3">
        <div class="p-3" v-if="userSettings">
            <div class="dropitem"
                    v-for="settings in userSettings"
                    :key="settings.pageId">
                <page :page="settings">
                </page>
            </div>
            <button type="button" class="btn btn-lg btn-primary"
                    :disabled="saving"
                    @click="onSubmit">
                <i class="fa fa-save"></i>
                {{ $t('save') }}
            </button>
            <div v-if="validationErrors" class="p-3">
                <h4 class="text-danger">
                    {{validationErrors}}
                </h4>
            </div>
        </div>
        <div v-else>
            {{ $t('missingSource') }}
        </div>
    </div>
</template>

<script>
import Page from '@/components/dynamicLayout/Page';
import personalizationService from '@/services/personalization.service';
import { mapGetters } from 'vuex';

export default {
    // TODO: delete file participant.js
        components: {
            Page
        },
        data() {
            return {
                saving: false,
                validationErrors: ''
            }
        },
        methods: {
            onSubmit() {
                this.saving = true;
                this.validationErrors = '';

                personalizationService
                    .saveDynamicLayoutSettings(this.getSortedPanels())
                    .then(response => {
                        this.saving = false;
                        this.$router.push({ path: `/` });
                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        });
                    }).catch(error => {
                        this.saving = false;
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        if (error.response.data.validationErrors) {
                            this.validationErrors = error.response.data.validationErrors;
                        }
                    });
            },
            getSortedPanels() {
                for (let i = 0; i < this.userSettings.length; i++) {
                    let panelSort = 1;
                    this.userSettings[i].settings.map(panel => {
                        panel.sort = panelSort++;
                        return panel;
                    });
                }

                return this.userSettings;
            }
        },
        computed: {
            ...mapGetters(['userSettings']),
        }
    }
</script>

<style scoped>
    .btn {
        margin-top: 3rem !important;
        margin-left: -1rem !important;
    }
</style>
